<div class="container-right-main fluid-container">
  <div class="mainDiv mainDiv-type2">
    <h2 mat-dialog-title class="title">Customize AI Advisor</h2>
    <!-- <p (click)="questions()">Go to FAQ'S</p> -->
    <div class="display-flex">
        <div class="float-left">
            <div class="faq-wrapper">
              <span (click)="questions()">Go to FAQ'S <img src="../../../assets/images/redirect-arrow.png"
                  alt="Go to FAQ'S" /></span>
            </div>
        </div>
        <div class="float-right">
          <button type="button" class="submit btn-red" (click)="onSubmit()">Save</button>
        </div>
    </div>
    <!-- <mat-dialog-actions align="start">
      <div class="buttonBtmDiv">
        <button type="button" class="submit" (click)="onSubmit()">Save</button>
      </div>
    </mat-dialog-actions>
    <div class="faq-wrapper">
      <span (click)="questions()">Go to FAQ'S <img src="../../../assets/images/redirect-arrow.png"
          alt="Go to FAQ'S" /></span>
    </div> -->
    <mat-dialog-content>
      <div class="scroll">
        <div class="nextDiv white-box">
          <!-- <div class="label-row">
              <label class="labeltext">Enable response from foundation model</label>
                  <mat-icon matTooltip="Retrieve the response from the large language model’s knowledge rather than from the aiadvisor product knowledge base." class="tooltip-icon">info</mat-icon>            

              <div class="button-div">
              <button type="button" [ngClass]="test ? 'active-btn-b' : 'inactive-btn'" (click)="firstcheck(false)">
              </button>
              <button type="button" [ngClass]="test ? 'inactive-btn' : 'active-btn'" (click)="firstcheck(true)">
              </button>
              </div>
          </div>
          <div class="label-row">
              <label class="labeltext"> Enable qualitative assessment</label>
              <div class="button-div">
              <button [ngClass]="test2 ? 'active-btn-b' : 'inactive-btn'" (click)="secondcheck(false)">
              </button>
              <button [ngClass]="test2 ? 'inactive-btn' : 'active-btn'" (click)="secondcheck(true)">
              </button>
              </div>
          </div>
          <div class="label-row">
              <label class="labeltext"> Enable voice interaction</label>
              <div class="button-div">
              <button [ngClass]="test3 ? 'active-btn-b' : 'inactive-btn'" (click)="thirdcheck(false)">
              </button>
              <button [ngClass]="test3 ? 'inactive-btn' : 'active-btn'" (click)="thirdcheck(true)">
              </button>
              </div>
          </div>
          <div class="label-row">
              <label class="labeltext">Rephrase query?</label>
              <div class="button-div">
              <button [ngClass]="test3 ? 'active-btn-b' : 'inactive-btn'" (click)="thirdcheck(false)">
              </button>
              <button [ngClass]="test3 ? 'inactive-btn' : 'active-btn'" (click)="thirdcheck(true)">
              </button>
              </div>
          </div>
          <div class="label-row">
              <label class="labeltext"> Enable video interaction</label>
              <mat-icon matTooltip="Activate the virtual avatar feature." class="tooltip-icon">info</mat-icon>
              <div class="button-div">
              <button [ngClass]="test4 ? 'active-btn-b' : 'inactive-btn'" (click)="fourthcheck(false)">
              </button>
              <button [ngClass]="test4 ? 'inactive-btn' : 'active-btn'" (click)="fourthcheck(true)">
              </button>
              </div>
          </div>
          <div class="label-row">
              <label class="labeltext"> Enable hybrid search</label>
              <div class="button-div">
              <button [ngClass]="test5 ? 'active-btn-b' : 'inactive-btn'" (click)="fivecheck(false)">
              </button>
              <button [ngClass]="test5 ? 'inactive-btn' : 'active-btn'" (click)="fivecheck(true)">
              </button>
              </div>
          </div>
          <div class="label-row">
              <label class="labeltext">Enable agent response</label>
              <div class="button-div">
              <button [ngClass]="test6 ? 'active-btn-b' : 'inactive-btn'" (click)="sixcheck(false)">
              </button>
              <button [ngClass]="test6 ? 'inactive-btn' : 'active-btn'" (click)="sixcheck(true)">
              </button>
              </div>
          </div> -->


          <div class="label-row panels">
            <label class="labeltext"> Text to speech enabled</label>
            <div class="panel-cont">
              <mat-icon matTooltip="Activate the speech feature." class="tooltip-icon">info</mat-icon>
              <mat-slide-toggle [(ngModel)]="textToSpeechControl"></mat-slide-toggle>
            </div>
          </div>
          <div *ngIf="textToSpeechControl">
            <div class="label-row panels">
              <!-- Radio buttons for Male and Female voice selection -->
              <label class="labeltext">
                <input type="radio" name="voiceType" value="Male" (change)="onSelectionChange()"
                  [(ngModel)]="selectedVoiceType"> Male Voice
              </label>
              <label class="labeltext">
                <input type="radio" name="voiceType" value="Female" (change)="onSelectionChange()"
                  [(ngModel)]="selectedVoiceType"> Female Voice
              </label>
            </div>

            <div class="label-row panels choose-voice-row">
              <!-- Dropdown for choosing voices -->
              <label class="labeltext" for="voiceDropdown">Choose Voice:</label>
              <div class="panel-cont type2">
                <select id="voiceDropdown" class="voiceDrop" [(ngModel)]="selectedVoice">
                  <option *ngFor="let voice of voiceOptions" [value]="voice.voiceId">{{ voice.label }}</option>
                </select>
                <button class="play-sample-btn" (click)="playSampleVoice()" [disabled]="!selectedVoice">
                  <div class="play-icon">
                    <i class="material-icons spin" *ngIf="voicePreviewState === 'loading'">autorenew</i>
                    <i class="material-icons" *ngIf="voicePreviewState === 'playing'">pause</i>
                    <i class="material-icons" *ngIf="voicePreviewState === 'idle'">play_arrow</i>
                  </div>
                  {{ voicePreviewState === 'loading' ? 'Loading...' : (voicePreviewState === 'playing' ? 'Stop' : 'Play sample') }}
                </button>
              </div>
            </div>

          </div>

          <p class="paraQueLite"> The selected voice will be the default one for all the modules </p>




        </div>
        <hr class="HR">
        <div class="nextDiv white-box">
          <div class="label-row panels">
            <label class="labeltext"> Enable file upload</label>
            <div class="panel-cont">
              <mat-icon matTooltip="Activate the file upload feature." class="tooltip-icon">info</mat-icon>
              <mat-slide-toggle [(ngModel)]="fileUploadControl"></mat-slide-toggle>
            </div>
          </div>
          <div class="label-row">
            <label class="labeltext"> Enable video interaction</label>
            <mat-icon matTooltip="Activate the virtual avatar feature." class="tooltip-icon">info</mat-icon>
            <mat-slide-toggle [(ngModel)]="videoInteractionEnabled"></mat-slide-toggle>
          </div>
          <div class="label-row">
            <label class="labeltext"> Enable Follow-up question</label>
            <mat-icon matTooltip="Allow the user to ask follow-up questions based on the previous conversation."
              class="tooltip-icon">info</mat-icon>
            <mat-slide-toggle [(ngModel)]="supplementaryQuestionEnabled"></mat-slide-toggle>
          </div>
            <div class="label-row" *ngIf="disable">
            <label class="labeltext"> Enable ShowPad link</label>
            <mat-icon matTooltip="Enable the ShowPad link for the user."
              class="tooltip-icon">info</mat-icon>
            <mat-slide-toggle [(ngModel)]="show_showpad_url"></mat-slide-toggle>
          </div>
        </div>
        <hr class="HR">
        <form [formGroup]="CustomizeForm">

          <div class="labeltext grey-box">
            <div>
              <p class="paraQue">How many days worth of chat history? <mat-icon
                  matTooltip="Access the chat conversation history for future reference."
                  class="tooltip-icon">info</mat-icon></p>
              <input type="text" formControlName="historyDays" class="InputFld" (keypress)="numericOnly($event)" />
            </div>
            <div>
              <p class="paraQue">Idle time in seconds required for Avatar to switch to passive mode. <mat-icon
                  matTooltip="Take into account the number of seconds the user is idle while using the Avatar; if the user remains idle, the Avatar will switch to passive mode."
                  class="tooltip-icon">info</mat-icon></p>

              <input type="text" formControlName="idleMinutes" class="InputFld" (keypress)="numericOnly($event)" />
            </div>
            <div>
              <p class="paraQue">How many historical context (Q&A) to remember for the next question? <mat-icon
                  matTooltip="The number of previous user chat conversations should be considered as context for the llm to prepare a response."
                  class="tooltip-icon">info</mat-icon></p>

              <input type="text" formControlName="historicalQA" class="InputFld" (keypress)="numericOnly($event)" />
            </div>
            <div>
              <p class="paraQue">No of reference document pages for LLM? <mat-icon
                  matTooltip="The number of top semantically matched document pages to be sent to the LLM for response preparation."
                  class="tooltip-icon">info</mat-icon></p>

              <input type="text" formControlName="top_k" class="InputFld" (keypress)="numericOnly($event)" />
            </div>
            <div>
              <p class="paraQue">Footer Message</p>
              <textarea formControlName="message" class="InputMsg">{{ ai_guideline_message }}</textarea>
            </div>
            <div>
              <p class="paraQue">Footer URL</p>
              <textarea formControlName="url" class="InputMsg">{{ ai_guideline_url }}</textarea>
            </div>
            <div>
              <p class="paraQue">User Guide</p>
              <textarea formControlName="user_guide" class="InputMsg">{{ user_guide }}</textarea>
            </div>
            <div>
              <p class="paraQue">App User Guide</p>
              <textarea formControlName="app_user_guide" class="InputMsg">{{ app_user_guide }}</textarea>
            </div>
            <!-- <div>
                      <p class="paraQue">No of context from AI Search?</p>
                      <input type="text" formControlName="retrieved_chunk_num" class="InputFld" (keypress)="numericOnly($event)" />
                  </div> -->
          </div>
          <!-- <div class="labeltext">
          <div>
              <p class="paraQue">How would you like aiadvisor to respond (overrides trainee preferences)?</p>
            </div>
          
        <mat-form-field appearance="fill" class="textarea-field">
          <textarea matInput formControlName="textArea" (change)="textARea()"></textarea>
        </mat-form-field>
      </div> -->
          <hr class="HR">
          <div class="grey-box">
            <div>
              <p class="paraQue">Data source URL</p>
              <textarea formControlName="data_source_url" class="InputMsg">{{ datasource?.datasource_url }}</textarea>
            </div>
            <div>
              <p class="paraQue">Dashboard URL</p>
              <textarea formControlName="dashboard_url" class="InputMsg">{{ datasource?.dashboard_url }}</textarea>
            </div>
            <div>
              <p class="paraQue">Job scheduler URL</p>
              <textarea formControlName="job_scheduler_url"
                class="InputMsg">{{ datasource?.job_scheduler_url }}</textarea>
            </div>
            <div>
              <p class="disclaimer paraQue">Header URL</p>
              <textarea formControlName="header_url" class="InputMsg">{{ datasource?.header_url }}</textarea>
            </div>
            <div>
              <p class="disclaimer paraQue">Header message</p>
              <textarea formControlName="header_message" class="InputMsg">{{ datasource?.header_message }}</textarea>
            </div>
          </div>
        </form>
        <!-- <hr class="HR">
        <div class="white-box">
          <app-schedule-outage #scheduleOutage></app-schedule-outage>
        </div> -->
      </div>
    </mat-dialog-content>

  </div>
</div>